<template>
    <div class="col-12" v-if="dashboardStore.filter !== 'Card'">
        <div class="card" :class="{ 'border-r-0': dashboardStore.filter === 'General' }" v-if="isDataLoaded">
            <div v-if="dashboardStore.filter === 'General'" class="card-body">
                <h3>Key metrics</h3>
                <div class="row">
                    <!-- 大螢幕時顯示 -->
                    <div class="col-xxl-2 p-0 mt-2 d-none d-xxl-block">
                        <h4>&nbsp;</h4>
                        <hr>
                        <div class="text-left col-12">This month</div>
                        <hr>
                        <div class="text-left col-12">Last month</div>
                        <hr>
                        <div class="text-left col-12">Year to date</div>
                    </div>
                    
                    <!-- Face value (Cash) -->
                    <div class="col-xxl-3 col-md-6 card-info p-0 mt-2">
                        <h4>Face value (Cash)</h4>
                        <hr>
                        <div class="row d-flex justify-content-between">
                            <div class="col-6 text-left d-xxl-none">This month</div>
                            <div class="col-xxl-12 col-6 card-value"><strong>{{ formatCurrency(face_value_cash?.this_month) ?? 0 }}</strong></div>
                        </div>
                        <hr>
                        <div class="row d-flex justify-content-between">
                            <div class="col-6 text-left d-xxl-none">Last month</div>
                            <div class="col-xxl-12 col-6 card-value"><strong>{{ formatCurrency(face_value_cash?.last_month) ?? 0 }}</strong></div>
                        </div>
                        <hr>
                        <div class="row d-flex justify-content-between">
                            <div class="col-6 text-left d-xxl-none">Year to date</div>
                            <div class="col-xxl-12 col-6 card-value"><strong>{{ formatCurrency(face_value_cash?.year_to_date) ?? 0 }}</strong></div>
                        </div>
                    </div>
                    
                    <!-- Face value (Bank) -->
                    <div class="col-xxl-3 col-md-6 card-info p-0 mt-2">
                        <h4>Face value (Bank)</h4>
                        <hr>
                        <div class="row d-flex justify-content-between">
                            <div class="col-6 text-left d-xxl-none">This month</div>
                            <div class="col-xxl-12 col-6 card-value"><strong>{{ formatCurrency(face_value_bank?.this_month) ?? 0 }}</strong></div>
                        </div>
                        <hr>
                        <div class="row d-flex justify-content-between">
                            <div class="col-6 text-left d-xxl-none">Last month</div>
                            <div class="col-xxl-12 col-6 card-value"><strong>{{ formatCurrency(face_value_bank?.last_month) ?? 0 }}</strong></div>
                        </div>
                        <hr>
                        <div class="row d-flex justify-content-between">
                            <div class="col-6 text-left d-xxl-none">Year to date</div>
                            <div class="col-xxl-12 col-6 card-value"><strong>{{ formatCurrency(face_value_bank?.year_to_date) ?? 0 }}</strong></div>
                        </div>
                    </div>
                    
                    <!-- Total Face value -->
                    <div class="col-xxl-4 col-md-12 card-info p-0 mt-2">
                        <h4>Total Face value</h4>
                        <hr>
                        <div class="row d-flex justify-content-between">
                            <div class="col-6 text-left d-xxl-none">This month</div>
                            <div class="col-xxl-12 col-6 text-green card-value"><strong>{{ formatCurrency(total_face_value?.this_month) ?? 0 }}</strong></div>
                        </div>
                        <hr>
                        <div class="row d-flex justify-content-between">
                            <div class="col-6 text-left d-xxl-none">Last month</div>
                            <div class="col-xxl-12 col-6 text-green card-value"><strong>{{ formatCurrency(total_face_value?.last_month) ?? 0 }}</strong></div>
                        </div>
                        <hr>
                        <div class="row d-flex justify-content-between">
                            <div class="col-6 text-left d-xxl-none">Year to date</div>
                            <div class="col-xxl-12 col-6 text-green card-value"><strong>{{ formatCurrency(total_face_value?.year_to_date) ?? 0 }}</strong></div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="dashboardStore.filter === 'Management'" class="card-body">
                <h3>Gross Margin</h3>
                <div class="row mt-4">
                    <!-- 大螢幕時顯示 -->
                    <div class="col-xxl-2 p-0 mt-2 d-none d-xxl-block">
                        <div class="text-left col-12">This month</div>
                        <hr>
                        <div class="text-left col-12">Last month</div>
                        <hr>
                        <div class="text-left col-12">Year to date</div>
                    </div>
                    
                    <!-- Face value (Cash) -->
                    <div class="col-xxl-3 col-md-6 card-info p-0 mt-2">
                        <div class="row d-flex justify-content-between">
                            <div class="col-6 text-left d-xxl-none">This month</div>
                            <div class="col-xxl-12 col-6 card-value"><strong>{{ formatCurrency(dashboardStore.management_dashboard?.key_metrics?.gross_margin?.this_month) ?? 0 }}</strong></div>
                        </div>
                        <hr>
                        <div class="row d-flex justify-content-between">
                            <div class="col-6 text-left d-xxl-none">Last month</div>
                            <div class="col-xxl-12 col-6 card-value"><strong>{{ formatCurrency(dashboardStore.management_dashboard?.key_metrics?.gross_margin?.last_month) ?? 0 }}</strong></div>
                        </div>
                        <hr>
                        <div class="row d-flex justify-content-between">
                            <div class="col-6 text-left d-xxl-none">Year to date</div>
                            <div class="col-xxl-12 col-6 card-value"><strong>{{ formatCurrency(dashboardStore.management_dashboard?.key_metrics?.gross_margin?.year_to_date) ?? 0 }}</strong></div>
                        </div>
                    </div>
                    <div class="col-xxl-1"></div>
                    <div class="col-xxl-6">
                        <h5>Change commission</h5>
                        <div class="row mt-4">
                            <div class="col">
                                <span class="f-16">VISA</span>
                                <input class="form-control" type="text" v-model="visaCommission" />
                            </div>
                            <div class="col">
                                <span class="f-16">Mastercard</span>
                                <input class="form-control" type="text" v-model="mastercardCommission" />
                            </div>
                            <div class="col">
                                <span class="f-16">EFTPOS</span>
                                <input class="form-control" type="text" v-model="eftposCommission" />
                            </div>
                            <div class="col">
                                <span class="f-16">AMEX</span>
                                <input class="form-control" type="text" v-model="amexCommission" />
                            </div>
                            <div class="col">
                                <span class="f-16">CUP</span>
                                <input class="form-control" type="text" v-model="cupCommission" />
                            </div>

                        </div>
                        <button class="btn btn-update mt-4" @click="updateCommission">Update</button>
                    </div> 
                </div>
            </div>
        </div>
        
        <div v-else>
            <p>Loading data...</p>
        </div>
    </div>
</template>

<script setup>
import { onMounted, ref, computed } from 'vue';
import { useDashboardStore } from '@/store/admin/dashboard';

const dashboardStore = useDashboardStore();

const face_value_cash = ref(null);
const face_value_bank = ref(null);
const total_face_value = ref(null);
const isDataLoaded = ref(false);

const formatCurrency = (value) => {
    const absValue = Math.abs(value); // 取得絕對值並固定為兩位小數
    return value < 0 ? `-$${absValue}` : `$${absValue}`;
};

const visaCommission = computed({
  get: () => {
    // 取得後端原始數值並附上 '%'
    const value = dashboardStore.management_dashboard?.commission?.Visa;
    return value !== undefined ? value + '%' : '';
  },
  set: (newValue) => {
    // 移除 "%" 並將結果回寫至 store（依需求確認此更新機制是否合適）
    dashboardStore.management_dashboard.commission.Visa = newValue.replace('%', '').trim();
  }
});

const mastercardCommission = computed({
  get: () => {
    const value = dashboardStore.management_dashboard?.commission?.Mastercard;
    return value !== undefined ? value + '%' : '';
  },
  set: (newValue) => {
    dashboardStore.management_dashboard.commission.Mastercard = newValue.replace('%', '').trim();
  }
});

const eftposCommission = computed({
  get: () => {
    const value = dashboardStore.management_dashboard?.commission?.EFTPOS;
    return value !== undefined ? value + '%' : '';
  },
  set: (newValue) => {
    dashboardStore.management_dashboard.commission.EFTPOS = newValue.replace('%', '').trim();
  }
});

const amexCommission = computed({
  get: () => {
    const value = dashboardStore.management_dashboard?.commission?.['American Express'];
    return value !== undefined ? value + '%' : '';
  },
  set: (newValue) => {
    dashboardStore.management_dashboard.commission['American Express'] = newValue.replace('%', '').trim();
  }
});

const cupCommission = computed({
  get: () => {
    const value = dashboardStore.management_dashboard?.commission?.Cup;
    return value !== undefined ? value + '%' : '';
  },
  set: (newValue) => {
    dashboardStore.management_dashboard.commission.Cup = newValue.replace('%', '').trim();
  }
});

const updateCommission = async () => {
  const payload = {
    visa: parseFloat(visaCommission.value.replace('%', '').trim()),
    mastercard: parseFloat(mastercardCommission.value.replace('%', '').trim()),
    eftpos: parseFloat(eftposCommission.value.replace('%', '').trim()),
    amex: parseFloat(amexCommission.value.replace('%', '').trim()),
    cup: parseFloat(cupCommission.value.replace('%', '').trim())
  };
  await dashboardStore.updateCommission(payload);
}


onMounted(async () => {
    // 確保數據已經加載完畢後再進行賦值
    await dashboardStore.fetchDashboard();
    face_value_cash.value = dashboardStore.key_metrics?.face_value_cash || {};
    face_value_bank.value = dashboardStore.key_metrics?.face_value_bank || {};
    total_face_value.value = dashboardStore.key_metrics?.total_face_value || {};
    isDataLoaded.value = true; // 數據加載完畢後設置為 true
});
</script>

<style scoped>
.card-info {
    text-align: center;
    font-size: 16px;
}

.border-r-0{
    border-radius: 0px 15px 15px 15px;
}

.text-left {
    text-align: left;
    font-size: 24px;
}

.text-green {
    color: #00c962;
}

.card-value {
    font-size: 24px;
}

hr {
    margin-bottom: 30px;
    border-top: 2px solid gray; /* 基本的hr線條顏色 */
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* 陰影效果 */
}

.btn-update{
    background: rgba(0, 201, 98, 1);
    color: black;
    border: none;
    width: 140px;
    height: 40px;
    border-radius: 30px;
    padding: 10px, 32px, 10px, 32px  ;
}

.btn-update:hover{
    background-color: #00b452;
}
</style>
